import { GlassmorphismThemeContextProvider, useGlassmorphismTheme } from './chunk-UIPXYAHD.mjs';
import { theme as theme$1 } from './chunk-7JGQWJZ6.mjs';
import { theme } from './chunk-D4M7VTYQ.mjs';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { useMemo } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';

var InnerProvider = (props) => {
  const { children } = props;
  const { mode } = useGlassmorphismTheme();
  const theme3 = useMemo(() => {
    return mode === "light" ? theme : theme$1;
  }, [mode]);
  return /* @__PURE__ */ jsxs(ThemeProvider, { theme: theme3, children: [
    /* @__PURE__ */ jsx(CssBaseline, {}),
    children
  ] });
};
var GlassmorphismProvider = (props) => {
  const { children, defaultMode = "light" } = props;
  return /* @__PURE__ */ jsx(GlassmorphismThemeContextProvider, { defaultMode, children: /* @__PURE__ */ jsx(InnerProvider, { children }) });
};

export { GlassmorphismProvider };
//# sourceMappingURL=chunk-N3FLNXED.mjs.map
//# sourceMappingURL=chunk-N3FLNXED.mjs.map